module.exports = __webpack_public_path__ + "img/icon-auth-phone.b8cfb7cc.svg";